var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"languages-menu"},_vm._l((_vm.languages),function(lang){return _c('a',{key:_vm.$id(lang.name),class:{ active: lang.value == _vm.value },on:{"click":function($event){return _vm.$emit('input', lang.value)}}},[_vm._v(_vm._s(lang.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }